<template>
  <transition name="showdialog" @after-leave="onTransitionEnd">
    <div class="dialog-base" v-if="isOpen" :class="{ open: isOpen }">
      <div class="dialog-wrap">
        <div class="contents">
          <div class="closebtn" @click="onCloseClick"><span></span></div>
          <div class="contents-wrap">
            <slot></slot>
          </div>
        </div>
        <div class="back-cover" @click="onCloseClick"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "dialogBase",
  data() {
    return {
      isOpen: false,
    }
  },
  props: {
    trigger: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  watch: {
    trigger(stat) {
      if(stat){
        document.body.style.overflow = 'hidden'
        document.body.style.position = 'fixed'
        document.body.style.width = '100%'
        this.isOpen = true
      } else {
        this.isOpen = false
      }
    }
  },
  methods: {
    onCloseClick() {
      this.isOpen = false
    },
    onTransitionEnd() {
      document.body.style.overflowX = 'hidden'
      document.body.style.overflowY = 'auto'
      document.body.style.position = 'static'
      document.body.style.width = 'auto'
      setTimeout(()=>{
        this.$emit('dialogClose')
      },0)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../../assets/sass/variables/mixin";
@import "../../../../../../../assets/sass/variables/colors";
.dialog-base {
  width: 100%;
  height: 100%;
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: 99990;
  .closebtn {
    width: 18px;
    height: 18px;
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
    z-index: 2;
    span {
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
      &::before,
      &::after {
        content: '';
        width: 25.45px;
        height: 3px;
        display: block;
        position: absolute;
        background: #bdbdbd;
        top: 50%;
        left: 50%;
      }
      &::before {
        transform: translate(-50%, -50%) scale(0.8) rotate(45deg);
      }
      &::after {
        transform: translate(-50%, -50%) scale(0.8) rotate(-45deg);
      }
    }
  }
  .dialog-wrap {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .back-cover {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.7);
    position: absolute;
    top: 0;
    left: 0;
  }
  .contents {
    $baseheight: 88vh;

    position: relative;
    min-height: 200px;
    // max-height: calc(100% - 16px - 16px);
    //height: $baseheight;
    max-height: $baseheight;
    width: calc(100% - 16px - 16px);
    background: white;
    z-index: 1;
    @include mq('w320'){
      width: calc(100% - 25px - 25px);
    }
    @include mq(){
      max-width: 325px;
    }
    .contents-wrap {
      position: relative;
      width: 100%;
      max-height: $baseheight;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}
.showdialog-enter-active,
.showdialog-leave-active {
  transition: all 200ms ease-out 0s;
}
.showdialog-enter, .showdialog-leave-to {
  opacity: 0;
}
.showdialog-enter-to, .showdialog-leave {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/dialogBase.vue